import { Scenarios } from '@jfs/network'

const addNewBeneficiary = {
  default: [
    {
      url: /beneficiary\/add/,
      method: 'POST',
      response: {
        status: 'SUCCESS',
        data: {
          beneficiaryId: '1821038411286220083',
        },
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /beneficiary\/add/,
      method: 'POST',
      responseCode: 501,
      response: { status: 'FAILURE', error: { code: '33607', message: 'User does not exist.' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { addNewBeneficiary }
